import { Realtime } from 'ably';

let client: Realtime | null = null;
let currentOrgId: string | null = null;

/**
 * Closes the shared Ably client and clears module state.
 * Call when the user has no organization (e.g. logout) so we don't hold a connection
 * with a token for a previous org.
 */
export const closeAblyClient = (): void => {
  if (client) {
    client.close();
    client = null;
    currentOrgId = null;
  }
};

/**
 * Shared Ably Realtime client for the given organization.
 * - Same org: returns existing client (messaging and job-status hooks share it).
 * - Different org: closes the old client (token was for previous org), creates a new one.
 * - Token is org-scoped so we must recreate when org changes.
 */
export const getAblyClient = (organizationId: string): Realtime => {
  if (client && currentOrgId === organizationId) {
    return client;
  }

  closeAblyClient();

  currentOrgId = organizationId;
  client = new Realtime({
    authUrl: '/api/ably-auth',
  });

  return client;
};
